module.exports = __webpack_public_path__ + "a1e1d65465c69a65f8d01226ff5237ec.png";